<template>
  <button
    type="button"
    :aria-label="ariaLabel || undefined"
    :aria-busy="isLoading || undefined"
    :disabled="disabled || isLoading"
    class="inline-flex items-center gap-x-1 px-3.5 py-2.5 h-[2.2rem] transition-all duration-200 ease-in-out rounded-md text-sm font-medium"
    :class="{
      'focus-visible:outline-primary-600 bg-gradient-to-t from-primary-600 to-primary-500 hover:from-primary-700 hover:to-primary-600 text-white':
        color === 'primary',
      'focus-visible:outline-secondary-600 bg-gradient-to-t from-secondary-600 to-secondary-500 hover:from-secondary-700 hover:to-secondary-600 text-white':
        color === 'secondary',
      'focus-visible:outline-red-600 bg-gradient-to-t from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white':
        color === 'error',
      'focus-visible:outline-tertiary-600 bg-gradient-to-t from-tertiary-600 to-tertiary-500 hover:from-tertiary-700 hover:to-tertiary-600 text-white':
        color === 'tertiary',
      'bg-white text-dark-neutral-500 border border-mid-neutral-100 hover:bg-light-neutral-300':
        color === 'neutral',
      'opacity-50 !cursor-not-allowed': disabled || isLoading,
    }"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    color?: "primary" | "secondary" | "error" | "tertiary" | "neutral";
    ariaLabel?: string;
    disabled?: boolean;
    isLoading?: boolean;
  }>(),
  {
    color: "primary",
    ariaLabel: undefined,
    disabled: false,
    isLoading: false,
  },
);
</script>
